import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconVideo = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7zm-1.998 10H4V7h12l.001 4.999L16 12l.001.001.001 4.999z" }) }));
const Memo = memo(SvgIconVideo);
export default Memo;
//# sourceMappingURL=IconVideo.js.map